<template>
  <div class="modal-window uts016 uts017 sec">
    <header class="modal-header">
      <div class="tit">{{$i18nUtil.trans("title.TodoInfo.002","할 일 상세")}}</div>
      <button @click="$emit('close')" class="btn_close">닫기</button>
    </header>

    <div class="modal-content">
      <div class="input-box">
        <textarea
          name=""
          id=""
          maxlength="100"
          :placeholder="this.$i18nUtil.trans('message.TodoInfo.002','할 일을 입력해주세요.')"
          v-model="todoInfo.todoMain.todoTitle"
          :disabled="
            todoInfo.todoList.regUserId != userInfo.userId ||
            todoInfo.todoList.todoStatus != 'P'
          "
          @input="error = false"
          @change="fnTodoTitleUpdate"
        ></textarea>
        <div class="error" v-if="error">{{$i18nUtil.trans("message.TodoInfo.013","할 일 내용을 입력해주세요.")}}</div>
        <div class="character-limit_box txtr"
            v-if="todoInfo.todoMain.todoTitle != '' && todoInfo.todoMain.todoTitle.length > 100">
          <span class="error">{{ $i18nUtil.trans("message.TodoInfo.003","입력글자를 초과하였습니다.") }} (<b>{{ todoInfo.todoMain.todoTitle.length }}</b>/100)</span>
          <!-- <span class="count">(<b>{{ todoInfo.todoMain.todoTitle.length }}</b>/100)</span> -->
        </div>
      </div>

      <ul class="list-table">
        <li>
          <dl>
            <dt v-if="$i18nUtil.getLanguage() === 'ko'">{{ $i18nUtil.trans("entity.todo.requester","요청자") }}/{{ $i18nUtil.trans("entity.todo.personInCharge","담당자") }}</dt>
            <dt v-else>{{ $i18nUtil.trans("entity.todo.requester","요청자") }}/<br />{{ $i18nUtil.trans("entity.todo.personInCharge","담당자") }}</dt>
            <dd>
              <div class="re-de">
                <div class="re">
                  <div class="droplayer tooltipmember relative">
                    <v-menu offset-y>
                      <template
                        v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on">
                          {{todoInfo.todoList.regUserName}}
                        </v-btn>
                      </template>
                      <div class="dropdown-list">
                        <UserTooltip :userId="todoInfo.todoList.regUserId"/>
                      </div>
                    </v-menu>
                  </div>
                </div>
                <div class="division"></div>
                <div class="de">
                  <div class="droplayer tooltipmember relative">
                    <v-menu offset-y>
                      <template
                        v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on">
                          {{todoInfo.todoList.chargerName}}
                        </v-btn>
                      </template>
                      <div class="dropdown-list">
                        <UserTooltip :userId="todoInfo.todoList.chargerId"/>
                      </div>
                    </v-menu>
                  </div>
                </div>
                <div v-if="modalInfo.receiverCount != null && modalInfo.receiverCount != 1" >
                  <button
                    type="button"
                    class="btn-txt-link"
                    @click="receiverListOpen(modalInfo.todoMainId)">
                    {{$i18nUtil.trans("message.PrevQrtUnit.004","조회")}}
                  </button>
                </div>
              </div>
            </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>{{ $i18nUtil.trans("entity.todo.filter.period","기간") }}</dt>
            <dd>
              <!-- <div class="calendar_box_grp"> -->
                <div class="calendar_box">
                  <datepicker
                    format="yyyy.MM.dd"
                    v-model="todoInfo.todoMain.todoStartDate"
                    locale="ko-KR"
                    :disabled="
                      todoInfo.todoList.regUserId != userInfo.userId ||
                      todoInfo.todoList.todoStatus != 'P'
                    "
                    @selected="fnTodoStartDateUpdate"
                  ></datepicker>
                </div>
                <span>~</span>
                <div class="calendar_box">
                  <datepicker
                    format="yyyy.MM.dd"
                    v-model="todoInfo.todoMain.todoEndDate"
                    locale="ko-KR"
                    :disabled-dates="endDisabledDate"
                    :disabled="
                      todoInfo.todoList.regUserId != userInfo.userId ||
                      todoInfo.todoList.todoStatus != 'P'
                    "
                    @selected="fnTodoEndDateUpdate"
                  ></datepicker>
                </div>
              <!-- </div> -->
            </dd>
          </dl>
        </li>
        <!-- <li v-if="todoInfo.todoList.todoStatus === 'C'"> -->
        <li>
          <dl>
            <dt>{{ $i18nUtil.trans("entity.todo.filter.completionDate","완료일") }}</dt>
            <dd>
              <div class="calendar_box" v-if="todoInfo.todoList.todoStatus === 'C'">
                <datepicker 
                  format="yyyy.MM.dd" 
                  v-model="todoInfo.todoList.terDate" 
                  locale='ko-KR'
                  :disabled="
                    todoInfo.todoList.regUserId != userInfo.userId &&
                    todoInfo.todoList.chargerId != userInfo.userId
                  "
                  @selected="fnTodoTerDateUpdate"
                ></datepicker>
              </div>
              <div class="nodata" v-else>
                <div class="txt" style="text-align:left;">{{ $i18nUtil.trans("entity.todo.status.incomplete","미완료") }}</div>
              </div>
            </dd>
          </dl>
        </li>
        <!-- <li>
          <dl>
            <dt>상태</dt>
            <dd
              v-if="
                todoInfo.todoList.chargerId === userInfo.userId ||
                todoInfo.todoList.regUserId === userInfo.userId
              "
            >
              <input
                type="radio"
                name="fin"
                id="name1"
                :checked="todoInfo.todoList.todoStatus === 'P'"
                @click="fnTodoCheckOK('P')"
              />
              <label for="name1">미완료</label>

              <input
                type="radio"
                name="fin"
                id="name2"
                :checked="todoInfo.todoList.todoStatus === 'C'"
                @click="fnTodoCheckOK('C')"
              />
              <label for="name2">완료</label>
            </dd>
            <dd v-else>
              <input
                type="radio"
                name="fin"
                id="name1"
                checked
                v-if="todoInfo.todoList.todoStatus === 'P'"
                disabled
              />
              <input type="radio" name="fin" id="name1" disabled v-else />
              <label for="name1">미완료</label>

              <input
                type="radio"
                name="fin"
                id="name2"
                checked
                disabled
                v-if="todoInfo.todoList.todoStatus === 'C'"
              />
              <input type="radio" name="fin" id="name2" disabled v-else />
              <label for="name2">완료</label>
            </dd>
          </dl>
        </li> -->
        <li>
          <dl>
            <dt>{{ $i18nUtil.trans("message.TodoInfo.015","업무보드 연결") }}</dt>
            <dd>
              <button
                type="button"
                class="btn_link_add"
                @click="todoLinkedModal2Open()"
                v-if="
                  (todoInfo.todoList.regUserId === userInfo.userId &&
                  linkList.length === 0) &&
                  todoInfo.todoList.todoStatus === 'P'
                "
              >{{ $i18nUtil.trans("button.paper.connect","보드 연결") }}
              </button>
              <button
                type="button"
                class="btn_link_add"
                @click="todoLinkedModal2Open()"
                v-if="
                  (todoInfo.todoList.regUserId === userInfo.userId &&
                  linkList.length > 0) &&
                  todoInfo.todoList.todoStatus === 'P'
                "
              >{{ $i18nUtil.trans("button.paper.changeConn","보드 연결 변경") }}
              </button>
              <div 
                class="board_add_box" 
                v-if="
                  todoInfo.todoList.regUserId === userInfo.userId &&
                  todoInfo.todoList.todoStatus === 'P'
                "
              >
                <div 
                  class="nodata" 
                  v-if="linkList.length === 0"
                >
                  <div class="txt">{{ $i18nUtil.trans("message.TodoInfo.004","업무보드를 연결하세요.") }}</div>
                </div>
                <div class="board" v-if="linkList.length > 0">
                  <!-- <div class="top">
                    <span v-if="linkList[0].groupKbn == 'PRO'"></span>
                    <span v-if="linkList[0].groupKbn == 'USER'">프라이빗</span>
                    <span v-if="linkList[0].groupKbn == 'CFRC'">회의/협의</span>
                    <span v-if="linkList[0].paperId != ''" class="dividing_line_ty3"></span>
                    <span v-if="linkList[0].paperId != ''">{{ linkList[0].categoryName }}</span>
                    <span v-if="linkList.length > 0" class="dividing_line_ty3"></span>
                    <button v-if="linkList.length > 0" type="button" class="btn-more-ico_small3" @click="todoLinkedListModal2Open()">
                      <span class="num">
                        <b v-if="linkList.length > 99">99+</b>
                        <b v-else>{{ linkList.length }}</b>
                        건</span> 더보기
                    </button>
                  </div>
                  <div class="btm">
                    <div v-if="linkList[0].paperId == '' && linkList[0].groupKbn == 'PRO'" class="tit ell-singleline">{{ linkList[0].projectName }}</div>
                    <div v-if="linkList[0].paperId == '' && linkList[0].groupKbn == 'CFRC'" class="tit ell-singleline">{{ linkList[0].categoryName }}</div>
                    <div v-else class="tit ell-singleline">{{ linkList[0].paperTitle }}</div>
                  </div> -->
                  <div class="btm">
                    <div class="tit ell-singleline">
                      <span @click="moveLocation(linkList[0])">{{ linkList[0].paperTitle }}</span>
                    </div>
                    <div class="btn-connect_wrap">
                        <button 
                          type="button" 
                          v-if="
                            todoInfo.todoList.regUserId === userInfo.userId &&
                            todoInfo.todoList.todoStatus === 'P'
                          "
                          @click="removeLinkConfirm(linkList[0].linkId, linkList[0].todoType)"
                        >{{ $i18nUtil.trans("button.terminateConn","연결 해제") }}</button>
                    </div>
                  </div>
                  <!-- <button v-if="linkList.length > 0" type="button" class="btn-more-ico_small3" @click="todoLinkedListModal2Open">
                    <span class="num">
                      <b v-if="linkList.length > 99">99+</b>
                      <b v-else>{{ linkList.length }}</b>
                      건</span> 더보기
                  </button> -->
                </div>
              </div>
              <div v-else-if="linkList.length > 0">
                <span 
                  @click="moveLocation(linkList[0])"
                  style="cursor: pointer;"
                >
                {{ linkList[0].paperTitle }}
                </span>
              </div>
              <div class="nodata" v-else>
                <div class="txt" style="text-align:left;">{{ $i18nUtil.trans("message.TodoInfo.016","미연결") }}</div>
              </div>
            </dd>
          </dl>
        </li>
      </ul>
    </div>
    <footer class="modal-footer">
      <button
        type="button"
        class="btn_ty2"
        v-if="
          todoInfo.todoList.regUserId === userInfo.userId
        "
        @click="fnTodoDeleteConfirm()"
      >
        {{ $i18nUtil.trans("button.delete","삭제") }}
      </button>
      <button 
        type="button" 
        class="btn_ty1"
        v-if="
          todoInfo.todoList.chargerId === userInfo.userId
        "
        @click="fnTodoCheckOK(todoInfo.todoList.todoStatus === 'P' ? 'C' : 'P')"
      >{{todoInfo.todoList.todoStatus === 'P' ? $i18nUtil.trans("entity.todo.status.completed","완료") : $i18nUtil.trans("entity.todo.status.completed.cancel","완료취소")}}
      </button>
      <!-- <button 
        type="button" 
        class="btn_ty1"
        v-else
      >{{todoInfo.todoList.todoStatus === 'P' ? "완료" : "완료취소"}}
      </button> -->
    </footer>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import EventBus from "@/js/eventbus/eventBus";
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";

import todoLinkedModal2 from "./TodoLinkedModal2.vue";
import todoLinkedListModal2 from "./TodoLinkedListModal2.vue";
import UserTooltip from "@/components/cowork/common/user/UserTooltip";

import receiverList from "@/components/cowork/general/board/todo/popup/ReceiverList.vue";

export default {
  components: {
    Datepicker,
    UserTooltip,
  },
  props: {
    modalInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      date: new Date(),
      //date: "2020.12.31",
      show: false,
      error: false,
      /* tenantId */
      tenantId: localStorage.getItem("tenantId"),
      /**
       * 2021.04.07 시작일 전체 선택 가능하도록 요청사항
      startDisabledDate: {
        to: new Date(this.$moment().subtract(1, "days")),
        from: new Date(this.$moment().subtract(0, "days"))
      },
      */
      delReason:'',
      endDisabledDate: {
        to: new Date(this.$moment().subtract(1, "days"))
      },
      todoInfo: {
        members: [],
        endDate: null,
        delReason: "",
        todoMain: {
          paperId: "",
          regDate: "",
          regUserId: "",
          regUserName: "",
          todoEndDate: "",
          todoMainId: "",
          todoStartDate: "",
          todoTitle: "",
        },
        todoList: {
          chargerId: "",
          chargerName: "",
          confirmYn: "",
          delReason: "",
          regDate: "",
          regUserId: "",
          regUserName: "",
          terDate: "",
          todoId: "",
          todoMainId: "",
          todoStatus: "",
        },
      },
      linkList: [
        {
          categoryName: "",
          groupKbn: "",
          paperId: "",
          paperTitle: "",
          projectName: "",
          todoId: "",
        },
      ],
      userInfo: {
        userId: null,
      },

      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
        },
      },

      todoDeleteFlag:false,
    };
  },
  mounted() {
    this.fnTodoInfoUpdate();
    this.getLinkList();
  },
  created() {
    this.getUserInfo();
    EventBus.$on("board_TodoInfo_getLinkList", (payload) => {
      this.getLinkList();
    });
  },
  watch:{
    todoDeleteFlag(){
      if(this.todoDeleteFlag){
        this.showConfirmDialog(
          { width: "400px" },
          this.$i18nUtil.trans("title.dialog.notice","알림"),this.$i18nUtil.trans("AG055"),this.$i18nUtil.trans("button.todo.delete","할 일 삭제"),
          this.fnTodoDelete,"",this.$i18nUtil.trans("button.dialog.cancel","취소")
        );
        this.todoDeleteFlag = false;
      }
    }
  },
  methods: {
    ...mapActions("modals", ["showToast", "showModal"]),
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    getUserInfo() {
      let obj = this;
      let reqData = {
        url: "/api/copaper/decision/userInfo",
        method: "post",
      };
      obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
        obj.userInfo = response.result;
      });
    },
    fnTodoInfoUpdate() {
      let self = this;
      /* TODO: userId를 사용해 사용자 이름을 얻어온다. */
      /* 현재 생성자와 다른경우 편집이 제한된다. (읽기전용) */
      this.fnTodoClearMember();
      let date = new Date();

      let obj = this;
      let reqData = {};
      reqData.url = "/api/copaper/todo/getTodo";
      reqData.method = "post";
      reqData.params = { todoId: this.modalInfo.todoId };
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          if (res.errorCode != null) {
            obj.$emit("close");
          } else {
            let show = false;
            if (res.result) {
              let result = res.result;
              if (result.todoMain && result.todoT) {
                /* 등록된 할 일인 경우 */
                let todoMain = result.todoMain
                let todoT = result.todoT[0];

                let startDate = new Date(todoMain.todoStartDate);
                let endDate = new Date(todoMain.todoEndDate);

                if(this.$i18nUtil.getLanguage() === 'ko') {

                }else{
                  todoT.regUserName = todoMain.regUserNameEn != null ? todoMain.regUserNameEn : todoMain.regUserName;
                  todoT.chargerName = todoT.chargerNameEn != null ? todoT.chargerNameEn : todoT.chargerName;
                }

                this.todoInfo.todoMain = todoMain;
                this.todoInfo.todoMain.todoStartDate = new Date(startDate);
                this.todoInfo.todoMain.todoEndDate = new Date(endDate);
                this.todoInfo.todoList = todoT;
                // 읽음처리
                if(this.todoInfo.todoList.confirmYn === 0) {
                  this.setConfirm();
                }
                this.setDisabledDate();
              }
            }
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    setConfirm() {
      let reqData = {};
      reqData.url = "/api/copaper/todo/confirm";
      reqData.method = "post";
      reqData.params = { todoId: this.modalInfo.todoId, chargerId: this.todoInfo.todoList.chargerId };
      this
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(res => {
          if (res.errorCode != null) {
            console.log(res.errorMessage);
          }
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    fnTodoClearMember() {
      /* Todo 멤버 모두 삭제 */
      let members = this.todoInfo.members;
      members.splice(0, members.length);
    },
    todoLinkedModal2Open() {
      // if(this.linkList.length > 0 && this.linkList[0].todoType === "WIDGET") {
      //   let msg = this.$i18nUtil.trans("message.TodoInfo.006","보드 위젯에서 연결된 보드입니다. 해당 보드에서 할 일을 삭제하세요.");
      //   this.showAlertDialog(msg);
      //   return;
      // }
      const modalInfo = {
        name: "todoLinkedModal2",
        obj: this.$modal,
        component: todoLinkedModal2,
        width: "800px",
       // height: "516px",
        todoId: this.modalInfo.todoId,
        paperId : this.linkList.length > 0 ? this.linkList[0].paperId : null,
        todoMainId : this.todoInfo.todoMain.todoMainId
      };
      this.showModal(modalInfo);
    },
    todoLinkedListModal2Open() {
      const modalInfo = {
        name: "todoLinkedListModal2",
        obj: this.$modal,
        component: todoLinkedListModal2,
        width: "800px",
        height: "495px",
        todoId: this.modalInfo.todoId,
        userChk:
          this.todoInfo.todoList.regUserId === this.userInfo.userId ||
          this.todoInfo.todoList.chargerId === this.userInfo.userId,
      };
      this.showModal(modalInfo);
    },
    getLinkList() {
      let obj = this;
      let reqData = {
        url: "/api/copaper/todo/getLinkList",
        method: "post",
        params: {
          todoId: this.modalInfo.todoId,
        },
      };
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function (res) {
          if (res.errorCode != null) {
            obj.$emit("close");
          } else {
            obj.linkList = res.result;
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    fnTodoTitleUpdate() {
      let obj = this;

      if(this.todoInfo.todoMain.todoTitle == null ||
        this.todoInfo.todoMain.todoTitle == '') {
        this.error = true;
        return;
      }

      let reqData = {
        url: "/api/copaper/todo/updateTodoTitle",
        method: "post",
        params: {
          todoId: this.todoInfo.todoList.todoId,
          todoTitle: this.todoInfo.todoMain.todoTitle,
        },
      };
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          EventBus.$emit("refreshTodoBoard", this.todoInfo.todoList.todoId);
          EventBus.$emit("refreshTodoNewPage", this.todoInfo.todoList.todoId);
          // if(this.modalInfo.todoSelectedblockId != null) {

          // }
          let msg = obj.$i18nUtil.trans("message.TodoInfo.008","할 일 내용이 변경되었습니다.");
          obj.toastInfo.message = msg;
          obj.showToast(obj.toastInfo);
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    fnTodoStartDateUpdate() {
      let obj = this;
      
      // datepicker selected값이 이전값이므로 nextTick을 사용
      this.$nextTick(() => {
        let startDate =
          obj.todoInfo.todoMain.todoStartDate == ""
            ? ""
            : obj.$moment(obj.todoInfo.todoMain.todoStartDate).format('YYYY.MM.DD');
        let reqData = {
          url: "/api/copaper/todo/updateTodoStartDate",
          method: "post",
          params: {
            todoId: this.todoInfo.todoList.todoId,
            todoStartDate: startDate,
          },
        };
        obj
          .COWORK_REST_SIMPLE_ACTION(reqData)
          .then((res) => {
            if(this.modalInfo.todoSelectedblockId != null) {
              EventBus.$emit("refreshTodoBoard", this.todoInfo.todoList.todoId);
            }

            if(obj.todoInfo.todoMain.todoStartDate > obj.todoInfo.todoMain.todoEndDate){
              obj.todoInfo.todoMain.todoEndDate = obj.todoInfo.todoMain.todoStartDate;
              obj.fnTodoEndDateUpdate(obj.todoInfo.todoMain.todoEndDate)
            }else{
              EventBus.$emit("refreshTodoNewPage", this.todoInfo.todoList.todoId);
              obj.toastInfo.message = obj.$i18nUtil.trans("message.TodoInfo.009","기간이 변경되었습니다.");
              obj.showToast(obj.toastInfo);
            }
            this.setDisabledDate();
          })
          .catch(function (err) {
            console.log(err);
          });
      })
    },
    fnTodoEndDateUpdate(date) {
      let obj = this;
      
      // datepicker selected값이 이전값이므로 nextTick을 사용
      this.$nextTick(() => {
        let endDate =
          obj.todoInfo.todoMain.todoEndDate == ""
            ? ""
            : obj.$moment(obj.todoInfo.todoMain.todoEndDate).format('YYYY.MM.DD');
        let reqData = {
          url: "/api/copaper/todo/updateTodoEndDate",
          method: "post",
          params: {
            todoId: this.todoInfo.todoList.todoId,
            todoEndDate: endDate,
          },
        };
        obj
          .COWORK_REST_SIMPLE_ACTION(reqData)
          .then((res) => {
            if(this.modalInfo.todoSelectedblockId != null) {
              EventBus.$emit("refreshTodoBoard", this.todoInfo.todoList.todoId);
            }
            EventBus.$emit("refreshTodoNewPage", this.todoInfo.todoList.todoId);
            this.setDisabledDate();
            obj.toastInfo.message = obj.$i18nUtil.trans("message.TodoInfo.009","기간이 변경되었습니다.");
            obj.showToast(obj.toastInfo);
          })
          .catch(function (err) {
            console.log(err);
          });
      })
    },
    setDisabledDate() {
      // this.startDisabledDate.from = this.todoInfo.todoMain.todoEndDate; // 2021.04.07 시작일 전체 선택 가능하도록 요청사항.
      this.endDisabledDate.to = this.todoInfo.todoMain.todoStartDate;
    },
    fnTodoTerDateUpdate() {
      let obj = this;
      
      // datepicker selected값이 이전값이므로 nextTick을 사용
      this.$nextTick(() => {
        let terDate =
          obj.todoInfo.todoList.terDate == ""
            ? ""
            : obj.$moment(obj.todoInfo.todoList.terDate).format('YYYY.MM.DD');
        let reqData = {
          url: "/api/copaper/todo/updateTodoTerDate",
          method: "post",
          params: {
            todoId: this.todoInfo.todoList.todoId,
            terDate: terDate,
          },
        };
        obj
          .COWORK_REST_SIMPLE_ACTION(reqData)
          .then((res) => {
            if(this.modalInfo.todoSelectedblockId == null) {
              EventBus.$emit("refreshTodoBoard", this.todoInfo.todoList.todoId);
              EventBus.$emit("refreshTodoNewPage", this.todoInfo.todoList.todoId);
            }
            obj.toastInfo.message = obj.$i18nUtil.trans("message.TodoInfo.010","완료일이 변경되었습니다.");
            obj.showToast(obj.toastInfo);
          })
          .catch(function (err) {
            console.log(err);
          });
      })
    },
    fnTodoCheckOK(param) {
      if (param === this.todoInfo.todoList.todoStatus) {
        return;
      }
      let obj = this;
      let todo = this.todoInfo.todoList;
      if (todo) {
        let reqData = {
          url: "/api/copaper/todo/complete",
          method: "post",
          params: {
            todoId: todo.todoId,
          },
        };
        obj
          .COWORK_REST_SIMPLE_ACTION(reqData)
          .then((res) => {
            if (obj.todoInfo.todoList.todoStatus === "P") {
              obj.toastInfo.message = obj.$i18nUtil.trans("TB020");
            } else if (this.todoInfo.todoList.todoStatus === "C") {
              obj.toastInfo.message = obj.$i18nUtil.trans("TB021");
            }
            // 완료일 변수에 저장
            obj.todoInfo.todoList.terDate = obj.date;
            obj.todoInfo.todoList.todoStatus = param;
            obj.$emit("refreshHomeContents");
            EventBus.$emit("refreshTodoBoard", todo.todoId);
            EventBus.$emit("refreshTodoNewPage", todo.todoId);
            obj.showToast(obj.toastInfo);

            this.refreshBoard(param);
          })
          .catch(function (err) {
            console.log(err);
          });
      }
    },
    refreshBoard(param){
      const self = this;
      self.COWORK_REST_SIMPLE_ACTION({
        params: { by:"todo", paperId: self.todoInfo.todoMain.paperId, todoId: self.todoInfo.todoList.todoId, update: true },
        url: "/api/copaper/paper/block/refreshBlockBy",
        method: "post",
      }).then((response) => { });
    },
    fnTodoDeleteConfirm() { 
      if(this.linkList.length == 0) {
        this.delReason ='delReasonIsNull';
        this.todoDeleteFlag = true;
      }else if(this.linkList.length > 0 && this.linkList[0].todoType === "UTIL"){
        this.delReason ='delReasonIsNull';
        this.todoDeleteFlag = true;
      }else if(this.todoInfo.todoMain.paperId != "" && this.todoInfo.todoMain.paperId != null){
        let obj = this;
        let reqData = {
          url: "/api/copaper/paper/getPaperInfo",
          method: "post",
          params: {
            paperId: this.todoInfo.todoMain.paperId
          },
        };
        obj.COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function (res) {
          if(res.errorCode == null){
            if(res.result.deleteYn == 1){
              // 이미 지워진 보드.
              obj.delReason ='deletedPaperBefore';
              obj.todoDeleteFlag = true;
            }else{
              // if(obj.linkList.length > 0 && obj.linkList[0].todoType === "WIDGET") {
              //   let msg = obj.$i18nUtil.trans("message.TodoInfo.006","보드 위젯에서 연결된 보드입니다. 해당 보드에서 할 일을 삭제하세요.");
              //   obj.showAlertDialog(msg);
              //   return;
              // }else{
              //   obj.delReason ='delReasonIsNull';
              //   obj.todoDeleteFlag = true; 
              // }
              obj.delReason ='delReasonIsNull';
              obj.todoDeleteFlag = true; 
            }
          }
        })
        .catch(function (err) {
          console.log(err);
        });
      }else{
        this.delReason ='delReasonIsNull';
        this.todoDeleteFlag = true;
      } 
    },
    fnTodoDelete() {
      let self = this;
      let param = {
        todoId: self.todoInfo.todoList.todoId,
        regUserId: self.todoInfo.todoList.regUserId, 
        chargerId : self.todoInfo.todoList.chargerId,
        delReason: this.delReason,
        todoMainId : this.todoInfo.todoMain.todoMainId
      };
      let uri = "/api/copaper/todo/todoDelete";
      self.$axios.post(uri, param).then((response) => {
        let msg = self.$i18nUtil.trans("message.TodoInfo.012","할 일이 삭제되었습니다.");
        self.toastInfo.message = msg;
        self.showToast(self.toastInfo);
        self.$emit("updateTodoList", this.modalInfo.todoSelectedblockId);
        self.$emit("refreshHomeContents");
        self.$emit("close");
      });
    },
    removeLinkConfirm(param, type) {
      // if(type === "WIDGET") {
      //   let msg = this.$i18nUtil.trans("message.TodoInfo.006","보드 위젯에서 연결된 보드입니다. 해당 보드에서 할 일을 삭제하세요.");
      //   this.showAlertDialog(msg);
      //   return;
      // }
      this.showConfirmDialog(
        { width: "400px" },
        this.$i18nUtil.trans("title.dialog.notice","알림"),
        this.$i18nUtil.trans("AB081"),
        this.$i18nUtil.trans("button.terminateConn","연결 해제"),
        this.removeLink,
        param,
        this.$i18nUtil.trans("button.dialog.cancel","취소")
      );
    },
    removeLink(param) {
      let obj = this;
      let reqData = {
        url: "/api/copaper/todo/removeLink",
        method: "post",
        params: {
          linkId: param.modalParam.toString(),
          paperId : this.linkList[0].paperId
        },
      };
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function (res) {
          obj.getLinkList();
          EventBus.$emit("board_TodoInfo_getLinkList", param.modalParam);
          EventBus.$emit("refreshTodoNewPage");
          EventBus.$emit("refreshTodoBoard");
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    moveLocation(location) {
      // 2021-01-13 paperId,TodoId를 이용 할일이 등록된 보드의 블럭아이디 조회.
      let obj = this;
      let reqData = {};
      reqData.params = {
          todoId: location.todoId,
          paperId: location.paperId
      };
      reqData.url = "/api/copaper/todo/getTodoPaperBlockId";
      reqData.method = "post";

      obj
      .COWORK_REST_SIMPLE_ACTION(reqData)
      .then((res) => {
          if (res.errorCode) {
              console.log(res.errorCode);
          } else {
              window.open("/general/boardTarget/" + location.paperId + "/" + res.result.paperBlockId, "_blank"); 
          }
      })
      .catch((err) => {
          console.log("axios err => ", err);
      });
    },
    /* 수신자 리스트 팝업 */
    receiverListOpen(param) {
      const modalInfo = {
        name: "receiverList",
        obj: this.$modal,
        component: receiverList,
        width: "800px",
        todoMainId: param,
      };
      this.showModal(modalInfo);
    },
  },
};
</script>
<style scoped>
/* 지역스타일 (Vue 객체스타일) */
</style>
<style> /* 전역스타일은 사용하지 말아 주세요. (board.css 에 추가 후 퍼블에 요청해주세요) */ </style>


// WEBPACK FOOTER //
// src/components/cowork/general/board/todo/popup/TodoInfo.vue